import Environment from '../Environments/base.environment';
export const APPLICATION_JSON = 'application/json';

//exporting keys based on Environment.
export const local_env = process.env.REACT_APP_ENV && process.env.REACT_APP_ENV.trim();
export const KEYS: any = local_env
  ? Environment.ENVIRONMENT_KEYS()
  : Object.fromEntries(Object.entries((window as any)?.ENV || {}));

export enum SERVER_ERROR_MESSAGES {
  serverErrorMsg = 'Error, please refresh and try again',
  unAuthorizedMsg = 'Login expired, Log Out and log back in to try again',
  timeoutMsg = 'Request timed out. Please try again later',
  generalMsg = 'Something went wrong, please try again later',
}
export enum CUSTOM_ERROR_CODE {
  Authorization_Error = 'Authorization_Error',
}

export const ANYWHERE = 'Anywhere';
export const APPOINTMENT_TOOLTIP_MESSAGE = 'Appointment not confirmed';
export const TOOLTIP_MESSAGE = 'Coming soon';
export const BookingFailed = 'Booking Failed';
export const OK_TEXT = 'OK';
export const CANCEL_TEXT = 'Cancel';
export const LOGOUT_TEXT = 'Log out';
export const RefreshResults = 'Refresh Results';
export const UpdateNow = 'Update Now';
export const InsertShipment = 'Insert Shipment';
export const FAVORITE_SEARCH_ADDED = 'Favorite search added';
export const FAVORITE_SEARCH_REMOVED = 'Favorite search removed';
export const WATCHED_LOAD_ADDED = 'Watched load added';
export const WATCHED_LOAD_REMOVED = 'Watched load removed';
export const LAST_SHIPMENT_MODAL_MESSAGE =
  'If you would like to book this shipment after your last assigned shipment, click cancel and then use Book Now.';

export const US_TIME_ZONE = 'US/Eastern';

export const stateLabels = [
  {
    label: 'State 1',
    name: 'state1',
    value: '',
  },
  {
    label: 'State 2',
    name: 'state2',
    value: '',
  },
  {
    label: 'State 3',
    name: 'state3',
    value: '',
  },
];
export const STATES = [
  {
    name: 'Alabama',
    code: 'AL',
  },
  {
    name: 'Alaska',
    code: 'AK',
  },
  {
    name: 'Arizona',
    code: 'AZ',
  },
  {
    name: 'Arkansas',
    code: 'AR',
  },
  {
    name: 'California',
    code: 'CA',
  },
  {
    name: 'Colorado',
    code: 'CO',
  },
  {
    name: 'Connecticut',
    code: 'CT',
  },
  {
    name: 'Delaware',
    code: 'DE',
  },
  {
    name: 'District Of Columbia',
    code: 'DC',
  },
  {
    name: 'Florida',
    code: 'FL',
  },
  {
    name: 'Georgia',
    code: 'GA',
  },
  {
    name: 'Hawaii',
    code: 'HI',
  },
  {
    name: 'Idaho',
    code: 'ID',
  },
  {
    name: 'Illinois',
    code: 'IL',
  },
  {
    name: 'Indiana',
    code: 'IN',
  },
  {
    name: 'Iowa',
    code: 'IA',
  },
  {
    name: 'Kansas',
    code: 'KS',
  },
  {
    name: 'Kentucky',
    code: 'KY',
  },
  {
    name: 'Louisiana',
    code: 'LA',
  },
  {
    name: 'Maine',
    code: 'ME',
  },
  {
    name: 'Maryland',
    code: 'MD',
  },
  {
    name: 'Massachusetts',
    code: 'MA',
  },
  {
    name: 'Michigan',
    code: 'MI',
  },
  {
    name: 'Minnesota',
    code: 'MN',
  },
  {
    name: 'Mississippi',
    code: 'MS',
  },
  {
    name: 'Missouri',
    code: 'MO',
  },
  {
    name: 'Montana',
    code: 'MT',
  },
  {
    name: 'Nebraska',
    code: 'NE',
  },
  {
    name: 'Nevada',
    code: 'NV',
  },
  {
    name: 'New Hampshire',
    code: 'NH',
  },
  {
    name: 'New Jersey',
    code: 'NJ',
  },
  {
    name: 'New Mexico',
    code: 'NM',
  },
  {
    name: 'New York',
    code: 'NY',
  },
  {
    name: 'North Carolina',
    code: 'NC',
  },
  {
    name: 'North Dakota',
    code: 'ND',
  },
  {
    name: 'Ohio',
    code: 'OH',
  },
  {
    name: 'Oklahoma',
    code: 'OK',
  },
  {
    name: 'Oregon',
    code: 'OR',
  },
  {
    name: 'Pennsylvania',
    code: 'PA',
  },
  {
    name: 'Rhode Island',
    code: 'RI',
  },
  {
    name: 'South Carolina',
    code: 'SC',
  },
  {
    name: 'South Dakota',
    code: 'SD',
  },
  {
    name: 'Tennessee',
    code: 'TN',
  },
  {
    name: 'Texas',
    code: 'TX',
  },
  {
    name: 'Utah',
    code: 'UT',
  },
  {
    name: 'Vermont',
    code: 'VT',
  },
  {
    name: 'Virginia',
    code: 'VA',
  },
  {
    name: 'Washington',
    code: 'WA',
  },
  {
    name: 'West Virginia',
    code: 'WV',
  },
  {
    name: 'Wisconsin',
    code: 'WI',
  },
  {
    name: 'Wyoming',
    code: 'WY',
  },
];
export const CANADA_STATES = [
  {
    name: 'Alberta',
    code: 'AB',
  },
  {
    name: 'British Columbia',
    code: 'BC',
  },
  {
    name: 'Manitoba',
    code: 'MB',
  },
  {
    name: 'New Brunswick',
    code: 'NB',
  },
  {
    name: 'Newfoundland and Labrador',
    code: 'NL',
  },
  {
    name: 'Nova Scotia',
    code: 'NS',
  },
  {
    name: 'Northwest Territories',
    code: 'NT',
  },
  {
    name: 'Nunavut',
    code: 'NV',
  },
  {
    name: 'Ontario',
    code: 'On',
  },
  {
    name: 'Prince Edward Island',
    code: 'PE',
  },
  {
    name: 'Quebec',
    code: 'QC',
  },
  {
    name: 'Saskatchewan',
    code: 'SK',
  },
  {
    name: 'Yukon',
    code: 'YK',
  },
];
export const COUNTRY = [
  {
    Country: 'US',
    CountryFullName: 'United States',
  },
  {
    Country: 'CA',
    CountryFullName: 'Canada',
  },
];

export const SEARCHRESULTS_ERRORTEXT =
  "We don't have any result right now. Please refine your search.";
export const WATCHEDRESULTS_ERRORTEXT = "You haven't Watched any loads yet";
export const SELECT_SEARCH_WARNING_TEXT =
  'Select a city, state or at least one state for the location';

export const pickupDateOffset = 3;
export const dropDateOffset = 10;

export enum OOPS_NO_RECORD_FOUND_MESSAGE {
  OOPS_TITLE = 'Error',
  OOPS_MESSAGE = 'Requested record not found. <br />Click ok to go back',
  PAGE_NOT_FOUND_MESSAGE1 = 'Oops!',
  PAGE_NOT_FOUND_MESSAGE2 = 'Page not Found.',
  PAGE_NOT_FOUND_MESSAGE3 = "We couldn't find the page",
  PAGE_NOT_FOUND_MESSAGE4 = 'Click ok to go back or click Homepage to go back to Home screen',
  BACK_BTN = 'Go Back',
  HOME_BTN = 'Home Page',
}

export enum COOKIE_IDS {
  SHIPMENT_ID = 'shipment_id',
  PREFERRED_TIME_FORMAT = 'preferred_time_format',
}

export enum PULL_TO_REFRESH {
  THRESHOLD = 20,
  TRIGGER_HEIGHT = 250,
  REFRESH_LOADER_TIMER_MILISEC = 1000,
}

export enum MY_LOADS_PAGINATION {
  PAGE_SIZE = 99,
}

export enum EXECUTIONSTATUS {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  STARTED = 'STARTED',
  IN_TRANSIT = 'IN_TRANSIT',
  DELIVERED = 'DELIVERED',
  COMPLETED = 'COMPLETED',
}

export enum MYLOADS_TABS {
  DRIVER_ASSIGNED = 'DriverAssigned',
  IN_TRANSIT = 'In-Transit',
  DELIVERED = 'Delivered',
}

export enum CONTENTSTACK_PARAMS {
  CONTENTTYPE_TABBED_CONTENT = 'tabbed_content,accordion_content,tabbed_accordion_content',
  FINANCIAL_INFO_TABS_UID = 'blt02f7492f1904507b',
  INFO_AND_FORMS_TABBED_ACCORDION_CONTENT_UID = 'blt59aba7e19a5d4f19',
  SUPPORT_TABS_UID = 'blt95e61b223ec6b667',
  ACCORDION_CONTENT = 'accordion_content',
  TABBED_ACCORDION_CONTENT = 'tabbed_accordion_content',
}

export enum FINANCIAL_INFO {
  SLUG_SETTLEMENT = 'blte77e55ac0e3dcb92',
  SETTLEMENT_DATE = 'settlementDate',
  SLUG_FUEL_TAX = 'bltd8cebea6bea99b65',
  FUEL_TAX_DATE = 'fuelTaxDate',
  SLUG_YTD = 'blta6302b347bdc4e36',
  YTD_DATE = 'revenueDeductionDate',
  TAX_FORMS = 'blt3c21ab81e62a20d3',
  SLUG_INFO_AND_FORMS = 'blt59aba7e19a5d4f19',
}

export const MinMaxErrorMsg = 'Maximum miles should be greater than minimum miles';
